<template>
  <ScipherLayout>
    <ThoughtSpotHeader :cohort="cohort" v-if="cohort" />
    <div class="container" v-if="cohort">
      <div class="search-background">
        <div class="search-container hvh-flex align-center px-1">
          <v-icon>mdi-magnify</v-icon>
          <input class="search-query grow-1 ml-2" type="text" v-model="searchQuery" placeholder="Ask any data question" @keydown.enter="executeSearch" />
          <div class="icon-circle small" v-if="searchQuery">
            <v-icon small color="black" @click="searchQuery = ''">mdi-close</v-icon>
          </div>
          <div class="icon-circle ml-1">
            <Icon width="18px" height="18px" @click="executeSearch">
              <IconBulb />
            </Icon>
          </div>
        </div>
      </div>
      <div id="ts-embed" />
    </div>
    <Loader v-if="isLoading" />
  </ScipherLayout>
</template>
<script>
import {
  init,
  SageEmbed,
  AuthType,
  EmbedEvent,
  Action,
} from '@thoughtspot/visual-embed-sdk';
import axios from '../../axios';
import Loader from '../../components/common/loader/Loader.vue';
import { errorDebug, toFormData } from '../../libraries/common';
import Icon from '../../components/common/icon/Icon.vue';
import IconBulb from '../../assets/icons/IconBulb.vue';
import ScipherLayout from '../../components/analytics/layout/ScipherLayout.vue';
import ThoughtSpotHeader from '../../components/cohorts/ThoughtSpotHeader.vue';
export default {
  components: { Loader, Icon, IconBulb, ScipherLayout, ThoughtSpotHeader },
  props: ['cohortId'],
  data() {
    return {
      cohort: null,
      isLoading: false,
      searchQuery: '',
      isSearchExecuted: false,
    };
  },
  methods: {
    showLoader() {
      this.isLoading = true;
    },
    hideLoader() {
      this.isLoading = false;
    },
    executeSearch() {
     var isProduction =  window['CurrentEnv'] === 'Production';
    var objectId = isProduction
      ? '14f59e32-f0cc-4d74-ac0f-9316d3bd5bf8'
      : '1b78af6c-84d1-49dd-9a25-7a72f1266b71';
    var orgId  = isProduction
      ? 169883887
      : 0 ;
    var dataSource = isProduction
      ? '07bccabc-4944-403a-9d6a-760bca74016a'
      : 'cf651d3a-5866-4ed6-9091-a489868ee2d8';
     

      init({
        thoughtSpotHost: 'https://eversana.thoughtspot.cloud',
        authType: AuthType.TrustedAuthTokenCookieless,
        disableTokenVerification: true,
        getAuthToken: () => axios.post('/Analytics/Thoughtspot/GetToken', toFormData({objectId, orgId }))
          .then(({ data }) => data.token),
      });
      // Instantiate SearchEmbed class
      const embed = new SageEmbed('#ts-embed', {
        frameParams: {
          width: '100%',
          height: '100%',
        },
        dataSource: dataSource,
        searchOptions: {
          searchQuery: `${this.searchQuery} for cohortid ${this.cohortId}`,
          executeSearch: true,
        },
        hiddenActions: [
          // Action.AddColumnSet,
          // Action.AddDataPanelObjects,
          // Action.AddFilter,
          // Action.AddFormula,
          // Action.AddParameter,
          // Action.AddQuerySet,
          // Action.AddTab,
          // Action.AddToFavorites,
          // Action.AddToWatchlist,
          // Action.AIHighlights,
          // Action.AnalysisInfo,
          // Action.AnswerChartSwitcher,
          // Action.AnswerDelete,
          // Action.AskAi,
          // Action.AxisMenuAggregate,
          // Action.AxisMenuConditionalFormat,
          // Action.AxisMenuEdit,
          // Action.AxisMenuFilter,
          // Action.AxisMenuGroup,
          // Action.AxisMenuNumberFormat,
          // Action.AxisMenuPosition,
          // Action.AxisMenuRemove,
          // Action.AxisMenuRename,
          // Action.AxisMenuSort,
          // Action.AxisMenuTextWrapping,
          // Action.AxisMenuTimeBucket,
          // Action.ChooseDataSources,
          // Action.CollapseDataSources,
          // Action.ConfigureFilter,
          // Action.CopyAndEdit,
          // Action.CopyLink,
          // Action.CopyToClipboard,
          // Action.CreateMonitor,
          // Action.CrossFilter,
          // Action.CustomizeHeadlines,
          // Action.Describe,
          // Action.Download,
          // Action.DownloadAsCsv,
          // Action.DownloadAsPdf,
          // Action.DownloadAsPng,
          // Action.DownloadAsXlsx,
          // Action.DownloadEmbraceQueries,
          // Action.DownloadTrace,
          // Action.DrillDown,
          // Action.DrillEdit,
          // Action.DrillExclude,
          // Action.DrillInclude,
          // Action.Edit,
          // Action.EditACopy,
          // Action.EditDetails,
          // Action.EditMeasure,
          Action.EditSageAnswer,
          // Action.EditTitle,
          // Action.EditTML,
          // Action.EnableContextualChangeAnalysis,
          // Action.ExplainInsight,
          // Action.Explore,
          // Action.ExportTML,
          // Action.ImportTML,
          // Action.InsertInToSlide,
          // Action.LiveboardInfo,
          // Action.LiveboardUsers,
          // Action.MakeACopy,
          // Action.ManageMonitor,
          // Action.ManagePipelines,
          // Action.MarkAsVerified,
          // Action.ModifySageAnswer,
          // Action.MoveToTab,
          // Action.OrganiseFavourites,
          // Action.PersonalisedViewsDropdown,
          Action.Pin,
          // Action.PinboardInfo,
          // Action.Present,
          // Action.QueryDetailsButtons,
          // Action.Relate,
          // Action.Remove,
          // Action.RemoveCrossFilter,
          // Action.RemoveFromWatchlist,
          // Action.RenameModalTitleDescription,
          // Action.ReplaySearch,
          // Action.ReportError,
          // Action.RequestAccess,
          // Action.RequestVerification,
          // Action.ResetLayout,
          Action.SageAnswerFeedback,
          Action.Save,
          // Action.SaveAsView,
          // Action.SaveUntitled,
          // Action.Schedule,
          // Action.SchedulesList,
          // Action.SearchOnTop,
          // Action.SendAnswerFeedback,
          // Action.Separator,
          Action.Share,
          // Action.ShareViz,
          Action.ShowSageQuery,
          // Action.ShowUnderlyingData,
          // Action.SpotIQAnalyze,
          // Action.SpotIQFollow,
          // Action.Subscription,
          // Action.SyncToOtherApps,
          // Action.SyncToSheets,
          // Action.SyncToSlack,
          // Action.SyncToTeams,
          // Action.TML,
          // Action.ToggleSize,
          // Action.Ungroup,
          // Action.Update,
          // Action.UpdateTML,
          // Action.VerifiedLiveboard,
        ],
        showObjectResults: false,
        hideSearchBarTitle: true,
        hideSageAnswerHeader: true,
        disableWorksheetChange: true,
        hideWorksheetSelector: true,
        hideAutocompleteSuggestions: true,
        showObjectSuggestions: false,
        hideSampleQuestions: true,
        customizations: {
          style: {
            customCSS: {
              rules_UNSTABLE: {
                '.eureka-search-bar-module__eurekaSearchBar': {
                  'display': 'none!important',
                },
                '.filter-panel-module__answerFilterPanelBody': {
                  'display': 'none!important',
                },
              }
            },
          },
        },
      });

      // Register event handlers
      embed
        .on(EmbedEvent.Init, this.showLoader)
        .on(EmbedEvent.Load, this.hideLoader)
        .on('answerPageLoading', payload =>
          console.log('Message received from embedded view: ' + JSON.stringify(payload))
        )
        .render();
    }
  },
  mounted() {
   console.log('Environment',process.env.NODE_ENV );
    this.isLoading = true;
    axios.get(`/Analytics/Cohorts/${this.cohortId}`)
      .then(({ data }) => this.cohort = data)
      .catch(errorDebug)
      .then(() => this.isLoading = false);
  },
}
</script>
<style lang="scss" scoped>
.search-background {
  background-color: rgb(219, 223, 231);
  padding: 24px;
  .search-container {
    height: 40px;
    background-color: white;
    border: 1px solid rgb(219, 223, 231);
    border-radius: 18px;

    input {
      height: 100%;
      &:focus-visible {
        outline: none;
      }
    }

    .icon-circle {
      background-color: rgb(234, 237, 242);
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;

      &.small {
        width: 24px;
        height: 24px;
      }
    }
  }
}
#ts-embed {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 240px);
}
</style>
